import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate, Navigate } from "react-router-dom";
import Lenis from "lenis";
import Home from "@/pages/Home";
import ProjectPage from "@/pages/ProjectPage";
import AdminPage from "@/pages/admin/AdminPage";
import FeedPage from "@/pages/FeedPage";
import PrintPage from "@/pages/PrintPage";
import EventsPage from "@/pages/EventsPage";
import SmokeRings from "@/components/SmokeRings";
import AmbientSmoke from "@/components/AmbientSmoke";
import { SHOW_FEED } from "@/config/site";

const SecretAdminTrigger = () => {
  const navigate = useNavigate();
  useEffect(() => {
    let buffer = [];
    const onKey = (e) => {
      if (e.target.closest("input, textarea, [contenteditable]")) return;
      const now = Date.now();
      buffer = buffer.filter((t) => now - t.time < 1500);
      if (e.key.toLowerCase() === "o") buffer.push({ time: now });
      if (buffer.length >= 3) {
        buffer = [];
        navigate("/admin");
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navigate]);
  return null;
};

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"], a[href^="/#"]');
      if (!anchor) return;
      const raw = anchor.getAttribute("href");
      const hash = raw.startsWith("/#") ? raw.slice(1) : raw;
      if (hash.length > 1) {
        const target = document.querySelector(hash);
        if (target) {
          e.preventDefault();
          lenis.scrollTo(target, { offset: -64 });
        }
        // target not on this page: let the browser/router navigate normally
      } else {
        e.preventDefault();
        lenis.scrollTo(0);
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);
};

function App() {
  useLenis();
  return (
    <BrowserRouter>
      <SecretAdminTrigger />
      <AmbientSmoke />
      <SmokeRings />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/work/:slug" element={<ProjectPage />} />
        <Route path="/print" element={<PrintPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/feed" element={SHOW_FEED ? <FeedPage /> : <Navigate to="/" replace />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
